{
  "shell": {
    "logo_alt": "Rhemn",
    "navUpgrade": "Haɓaka",
    "navBilling": "Biyan kuɗi"
  },
  "upgrade": {
    "badge": "Rhemn Pro",
    "title": "Shafinka. <em>Zikirinka</em>.<br />An ɗaukaka.",
    "subtitle": "Kowane fasali da kake buƙata don rana mai niyya — daga lokutan sallah da tunanin aya ta AI zuwa yanayi da ayyuka masu fifiko — a cikin sabon shafi guda mai kwanciyar hankali, mai kyau.",
    "comparison_aria": "Kwatancen tsari",
    "free": {
      "tierLabel": "Na yanzu",
      "tierName": "Kyauta",
      "freeLabel": "Kyauta kullum",
      "list_aria": "Fasalolin tsarin kyauta"
    },
    "pro": {
      "list_aria": "Fasalolin tsarin Pro",
      "tierLabel": "Haɓaka zuwa",
      "tierName": "Pro",
      "pricePeriod": "/ wata",
      "priceAlt": "ko $39.99 / shekara"
    },
    "freeFeatures": {
      "clockDate": "Nuna agogo da kwanan wata",
      "verseOfDay": "Ayar Alƙur'ani ta yini",
      "dailyBackground": "Hoton bayan fage na yini",
      "qiblaCompass": "Kamfas na Alƙibla",
      "basicTasks": "Ayyuka na asali"
    },
    "proFeatures": {
      "weatherForecast": "Hasashen yanayi na kwana 5",
      "verseFavorites": "Ajiye da bincika ayoyin da ake so",
      "notesAi": "Bayanai da nazarin AI",
      "priorityTasks": "Sarrafa ayyuka masu fifiko",
      "verseReflection": "Tunanin aya da AI"
    },
    "plans": {
      "monthly": {
        "label": "Na wata-wata",
        "price": "$4.99",
        "period": "/ wata",
        "note": "Ana biya kowane wata"
      },
      "yearly": {
        "label": "Na shekara-shekara",
        "price": "$39.99",
        "period": "/ shekara",
        "note": "Wata biyu kyauta",
        "badge": "Ajiye 33%"
      }
    },
    "pricingTitle": "Rhemn Pro",
    "pricingDesc": "Soke a kowane lokaci. Damarka tana ci gaba har ƙarshen lokacin biyan kuɗi ba tare da ƙarin caji ba.",
    "billingPeriod_aria": "Lokacin biyan kuɗi",
    "cta": "Ci gaba zuwa biyan kuɗi mai aminci",
    "ctaLoading": "Ana tura zuwa biyan kuɗi…",
    "promoManual": "Shigar da lambar {{code}} a shafi na gaba don samun rangwamenka.",
    "signingUpAs": "Ana yin rajista a matsayin {{account}}",
    "trustSignals_aria": "Alamomin amana",
    "reassurance": {
      "secureCheckout": "Biyan kuɗi mai aminci ta Stripe",
      "cancelAnytime": "Soke a kowane lokaci, babu tambaya",
      "accessUntilEnd": "Damar shiga har ƙarshen lokaci"
    },
    "errors": {
      "restoreSession": "Ba a iya dawo da zamanka ba. Da fatan sake gwadawa daga manhajar.",
      "checkoutFailed": "An kasa fara biyan kuɗi. Da fatan sake gwadawa."
    }
  },
  "upgradeStatus": {
    "unlockedFeatures_aria": "Fasalolin da aka buɗe",
    "unlockedFeatures": {
      "weatherForecast": "Hasashen yanayi na kwana 5",
      "verseFavorites": "Ajiye da bincika ayoyin da ake so",
      "notesAi": "Bayanai da nazarin AI",
      "priorityTasks": "Sarrafa ayyuka masu fifiko",
      "verseReflection": "Tunanin aya da AI"
    },
    "success": {
      "title": "Barka da zuwa Pro",
      "desc": "Biyan kuɗinka yana aiki. Koma zuwa manhajar don samun duka fasalolin Pro suna jiranka.",
      "viewBilling": "Duba cikakkun bayanan biyan kuɗi",
      "closeTab": "Rufe wannan shafi"
    },
    "cancel": {
      "title": "An soke biyan kuɗi",
      "desc": "Babu damuwa — ba a canza tsarinka ba kuma ba a caje ka ba. Za ka iya haɓakawa duk lokacin da ka shirya.",
      "backToUpgrade": "Komawa zuwa haɓakawa",
      "returnToExtension": "Komawa zuwa manhajar"
    }
  },
  "billing": {
    "title": "Biyan kuɗi",
    "subtitle": "Sarrafa biyan kuɗinka da duba tarihin biyan kuɗi.",
    "subscription_aria": "Matsayin biyan kuɗi",
    "subscriptionTitle": "Biyan kuɗi",
    "loading_aria": "Ana lodin bayanan biyan kuɗi",
    "planPro": "Rhemn Pro",
    "planFree": "Rhemn Free",
    "statusLabels": {
      "active": "Mai aiki",
      "trialing": "Gwaji kyauta",
      "past_due": "Ya wuce lokaci",
      "unpaid": "Ba a biya ba",
      "canceled": "An soke",
      "incomplete": "Bai cika ba",
      "none": "Babu biyan kuɗi"
    },
    "planValues": {
      "proYearly": "Pro · Na shekara",
      "proMonthly": "Pro · Na wata"
    },
    "warnings": {
      "paymentFailedTitle": "Biyan kuɗi ya kasa",
      "paymentFailedDesc": "Biyan kuɗinka na ƙarshe bai yi nasara ba. Sabunta hanyar biyan kuɗinka ta Sarrafa Biyan Kuɗi don ci gaba da damar Pro.",
      "trialEndingTitle": "Gwaji yana gab da ƙarewa",
      "trialEndingToday": "Gwajinka na kyauta yana ƙarewa yau a {{date}}. Ƙara hanyar biyan kuɗi don riƙe fasalolin Pro ɗinka.",
      "trialEndingInDays_one": "Gwajinka na kyauta yana ƙarewa cikin kwana {{count}} a {{date}}. Ƙara hanyar biyan kuɗi don riƙe fasalolin Pro ɗinka.",
      "trialEndingInDays_other": "Gwajinka na kyauta yana ƙarewa cikin kwanaki {{count}} a {{date}}. Ƙara hanyar biyan kuɗi don riƙe fasalolin Pro ɗinka."
    },
    "cancellationScheduled": "An tsara soke. Kana riƙe cikakkiyar damar Pro har <strong>{{date}}</strong>.",
    "sublabel": {
      "trialEndsToday": "Gwaji yana ƙarewa yau",
      "trialDaysRemaining_one": "kwana {{count}} ya rage a gwaji",
      "trialDaysRemaining_other": "kwanaki {{count}} sun rage a gwaji",
      "renews": "Yana sabuntawa {{date}}",
      "accessUntil": "Damar shiga har {{date}}"
    },
    "kv": {
      "status": "Matsayi",
      "nextRenewal": "Sabuntawa ta gaba",
      "trialEnds": "Gwaji yana ƙarewa",
      "trialDaysLeft_one": "kwana {{count}} ya rage",
      "trialDaysLeft_other": "kwanaki {{count}} sun rage",
      "endsToday": "yana ƙarewa yau",
      "plan": "Tsari"
    },
    "upgradeNudge": {
      "title": "Buɗe fasalolin Pro",
      "desc": "Yanayi, lokutan sallah, tunanin aya ta AI da ƙari — $4.99/wata ko $39.99/shekara.",
      "cta": "Haɓaka"
    },
    "actions": {
      "manageBilling": "Sarrafa biyan kuɗi da hanyar biya",
      "cancelConfirmTitle": "Soke biyan kuɗinka?",
      "cancelConfirmDesc": "Za ka riƙe cikakkiyar damar Pro har ƙarshen lokacin biyan kuɗinka na yanzu. Babu wani mayar da kuɗi na ɓangare.",
      "canceling": "Ana sokewa…",
      "yesCancel": "Eh, soke",
      "keepPro": "Riƙe Pro",
      "cancelSubscription": "Soke biyan kuɗi"
    },
    "noSubscription": "Ba a samu biyan kuɗi ba.",
    "paymentHistory_aria": "Tarihin biyan kuɗi",
    "paymentHistoryTitle": "Tarihin biyan kuɗi",
    "invoices_aria": "Takardun biya",
    "invoiceView": "Duba",
    "invoiceView_aria": "Duba takardar biya daga {{date}}",
    "noInvoices": "Babu takardun biya har yanzu.",
    "dangerZone_aria": "Yankin haɗari",
    "dangerZoneTitle": "Yankin haɗari",
    "deleteAccountTitle": "Share asusu",
    "deleteAccountDesc": "Share asusunka da duka bayanan da ke da alaƙa har abada — ayyuka, bayanai, waɗanda ake so, da tarihin biyan kuɗi. Ba a iya juyar da wannan aiki ba.",
    "deleteAccountBtn": "Share asusu",
    "deleteConfirm": {
      "warning": "Wannan zai kasance nan take kuma har abada:",
      "list": {
        "deleteContent": "Share duka ayyukanka, bayanai, da ayoyin da ake so",
        "cancelSubscription": "Soke kowane biyan kuɗi mai aiki (babu mayarwa don lokacin da ba a yi amfani ba)",
        "removeAccount": "Cire asusunka daga bayananmu",
        "signOut": "Fitar da kai daga duka na'urori"
      },
      "typeToConfirm": "Rubuta <strong>DELETE</strong> don tabbatarwa",
      "inputPlaceholder": "DELETE",
      "deleting": "Ana sharewa…",
      "confirmBtn": "Share asusuna har abada",
      "cancelBtn": "Soke"
    },
    "errors": {
      "loadFailed": "An kasa lodin bayanan biyan kuɗi.",
      "cancelFailed": "An kasa soke biyan kuɗi.",
      "deleteFailed": "An kasa share asusu. Da fatan sake gwadawa ko tuntuɓi tallafi.",
      "portalFailed": "An kasa buɗe tashar biyan kuɗi."
    }
  },
  "privacy": {
    "tocLabel": "Manufar Sirri",
    "toc_aria": "Jadawalin abubuwan ciki",
    "lastUpdated": "An sabunta ƙarshe<br />22 Satumba, 2026",
    "sections": {
      "overview": "Bayyani",
      "informationWeCollect": "Bayanan da Muke Tarawa",
      "connectedServices": "Ayyukan da Aka Haɗa (Google, Todoist, Apple)",
      "howWeUse": "Yadda Muke Amfani da Bayananka",
      "howWeShare": "Yadda Muke Raba Bayananka",
      "dataRetention": "Riƙe Bayanai",
      "yourRights": "Haƙƙin Sirrinka",
      "california": "Mazaunan California (CCPA/CPRA)",
      "cookies": "Cookies da Ajiya na Gida",
      "security": "Tsaron Bayanai",
      "changes": "Canje-canje ga Wannan Manufa",
      "contact": "Tuntuɓe Mu"
    },
    "headings": {
      "informationWeCollect": "Bayanan da Muke Tarawa",
      "connectedServices": "Ayyukan da Aka Haɗa (Google, Todoist, Apple)",
      "howWeUse": "Yadda Muke Amfani da Bayananka",
      "howWeShare": "Yadda Muke Raba Bayananka",
      "dataRetention": "Riƙe Bayanai",
      "yourRights": "Haƙƙin Sirrinka",
      "california": "Mazaunan California (CCPA / CPRA)",
      "cookies": "Cookies da Ajiya na Gida",
      "security": "Tsaron Bayanai",
      "changes": "Canje-canje ga Wannan Manufa",
      "contact": "Tuntuɓe Mu"
    }
  },
  "deleteAccount": {
    "intro": "Share asusunka zai goge har abada:",
    "list": {
      "account": "Asusunka da bayanan martaba",
      "tasks": "Duk ayyuka",
      "notes": "Duk bayanai",
      "verses": "Ayoyin da aka ajiye",
      "billing": "Bayanan biyan kuɗi"
    },
    "irreversible": "Ba za a iya mayar da wannan ba.",
    "appleNotice": "Share asusunka ba ya soke biyan kuɗin da aka saya ta App Store. Don Allah ka soke shi kuma a Saituna → Apple ID → Subscriptions.",
    "manageSubscription": "Sarrafa biyan kuɗi",
    "continueBtn": "Ci gaba da sharewa",
    "keepBtn": "Ajiye asusuna",
    "confirmTitle": "A share asusunka?",
    "confirmDesc": "Za a share asusunka da duk bayanansa har abada. Ba za a iya mayar da wannan ba.",
    "confirmBtn": "Share asusuna har abada",
    "deleting": "Ana sharewa…",
    "error": "Ba mu iya share asusunka ba. Don Allah duba haɗin yanar gizonka ka sake gwadawa."
  }
}
